angular.module('NumbersEditor')
    .controller('SearchController', [
        '$scope', 'SearchFactory', '$location', '$rootScope', '$routeParams', '$document', 'appInfoFactory',
        function ($scope, searchFactory, $location, $rootScope, $routeParams, $document, appInfoFactory) {

            init();

            function init() {
                $rootScope.SetAppTitle("Search", "Search Games");
                $scope.Games = undefined;

                appInfoFactory.getDateTime()
                    .success(function (dateTime) {
                        var today = new Date(JSON.parse(dateTime));
                        $scope.searchDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
                        initWatch();
                    }).error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });


                $scope.opened = false;
            };

            function initWatch() {
                $scope.$watch('searchDate', function () {
                    $scope.Games = undefined;
                    searchGames();
                });
            }

            function searchGames() {
                searchFactory.searchGame(new Date($scope.searchDate))
                    .success(function (games) {
                        $scope.Games = games;
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            }

            $document.bind('keypress', function ($event) {
                if ($event.which === 13) {
                    $("#btnsearchdate").click();
                }
            });

            $scope.go = function (view, id, sportCode, startDate) {
                $location.path(view + '/' + id).search({ sportCode: sportCode, startDate: startDate });
            };

            $scope.open = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.opened = true;
            };
        }
    ]);